{
  "analyse": {
    "title": "Digitalkan tapak",
    "intro": "Kelaskan tapak daripada imej satelit dan dapatkan laporan.",
    "site": "Tapak",
    "noSites": "Simpan sempadan tapak pada peta dahulu, kemudian analisisnya di sini.",
    "capture": "Imej",
    "loadingCaptures": "Mencari imej…",
    "noCaptures": "Belum ada imej yang meliputi tapak ini.",
    "capturedOn": "Dirakam {{date}}",
    "captureDetail": "{{label}} · {{provider}} · {{gsd}} m setiap piksel",
    "analytics": "Model",
    "names": {
      "land_cover": "Litupan tanah",
      "buildings": "Bangunan",
      "green_water": "Hijau & air",
      "roads_paved": "Jalan & turapan"
    },
    "run": "Jalankan analisis",
    "running": "Menganalisis…",
    "queued": "Menunggu untuk bermula…",
    "compared": "Dibandingkan dengan laporan terdahulu tapak ini.",
    "done": "Analisis selesai.",
    "viewReport": "Buka laporan",
    "failed": "Analisis tidak selesai.",
    "tryAgain": "Cuba lagi",
    "showOnMap": "Tunjuk pada peta",
    "hideOnMap": "Sembunyi dari peta",
    "duration": "Selesai dalam {{duration}}",
    "captureOption": "{{date}} · {{provider}} · {{gsd}} m"
  },
  "page": {
    "title": "Laporan tapak",
    "back": "Kembali ke ruang kerja",
    "print": "Cetak",
    "captured": "Dirakam {{date}}",
    "generated": "Dijana {{date}}",
    "model": "Model {{version}}",
    "processed": "Diproses dalam {{duration}}",
    "preparedFor": "Disediakan untuk {{organisation}}",
    "unsupported": "Laporan ini dalam format yang lebih baharu daripada yang boleh dipaparkan halaman ini. Muat semula untuk mengemas kini.",
    "figures": {
      "siteArea": "Keluasan tapak",
      "buildings": "Bangunan",
      "greenWater": "Hijau & air",
      "roadsPaved": "Jalan & turapan",
      "ofSite": "{{pct}}% daripada tapak",
      "coverage": "{{pct}}% tapak diliputi"
    },
    "landCover": {
      "title": "Litupan tanah",
      "class": "Kelas",
      "area": "Keluasan (ha)",
      "share": "Bahagian",
      "patches": "Tompok"
    },
    "change": {
      "title": "Perubahan sejak {{date}}",
      "titleUndated": "Perubahan sejak laporan terdahulu",
      "none": "Ini laporan pertama untuk tapak ini, jadi belum ada perbandingan.",
      "before": "Sebelum (ha)",
      "now": "Kini (ha)",
      "delta": "Perubahan (ha)",
      "deltaShare": "Perubahan (mata)",
      "buildings": "Bangunan: {{before}} → {{after}}"
    },
    "buildings": {
      "title": "Bangunan",
      "count": "Bangunan",
      "footprint": "Jumlah tapak binaan",
      "median": "Saiz median",
      "largest": "Terbesar",
      "density": "Setiap hektar"
    },
    "map": "Peta",
    "downloads": {
      "title": "Muat turun",
      "classification_cog": "Pengelasan (GeoTIFF)",
      "report_data": "Data laporan (JSON)",
      "report_pdf": "Laporan tapak (PDF)",
      "export_bundle": "Fail GIS (ZIP)",
      "download": "Muat turun"
    },
    "method": "Keluasan diukur dalam {{crs}}, grid ukur tempatan tapak. Keluasan dikelaskan {{classified}} ha daripada {{site}} ha keluasan tapak yang diukur. Pengelasan oleh {{model}}.",
    "history": {
      "title": "Sejarah laporan",
      "current": "Laporan ini"
    }
  },
  "flow": {
    "label": "Langkah pendigitalan",
    "steps": {
      "area": "Kawasan",
      "capture": "Imej",
      "analytics": "Analitik",
      "run": "Jalankan",
      "report": "Laporan"
    },
    "areaHint": "Pilih tapak yang disimpan. Untuk menambah tapak, lukis sempadan pada peta.",
    "siteArea": "{{area}} ha · {{crs}}",
    "model": "Peta litupan tanah (8 kelas)",
    "modelHint": "Satu laluan model. Laporan meliputi setiap kelas, termasuk bangunan, kawasan hijau dan air, serta jalan dan kawasan berturap.",
    "describe": {
      "land_cover": "Setiap kelas, keluasan dan bahagiannya dalam tapak.",
      "buildings": "Tapak binaan, bilangan, saiz dan liputannya.",
      "green_water": "Pokok, rumput, pertanian dan air.",
      "roads_paved": "Jalan dan permukaan berturap."
    },
    "cancel": "Batalkan larian",
    "cancelled": "Larian telah dibatalkan.",
    "retry": "Cuba lagi",
    "startAgain": "Mulakan analisis baharu",
    "runNeeds": "Pilih tapak, imej dan sekurang-kurangnya satu analitik untuk dijalankan.",
    "runIdle": "Pilih tapak, imej dan sekurang-kurangnya satu analitik di atas, kemudian tekan Jalankan analisis.",
    "runReady": "Sedia untuk dijalankan pada {{summary}}. Tekan Jalankan analisis di bawah; kemajuan dipaparkan di sini.",
    "runDone": "Analisis selesai. Laporannya di bawah, dan anda boleh menjalankannya semula.",
    "reportEmpty": "Jalankan analisis untuk melihat laporannya di sini."
  },
  "dock": {
    "title": "Larian",
    "empty": "Belum ada larian. Mulakan dari tab Analisis atau Reka Bentuk.",
    "status": {
      "queued": "Dalam giliran",
      "running": "Sedang berjalan",
      "succeeded": "Berjaya",
      "failed": "Gagal",
      "cancelled": "Dibatalkan",
      "rejected": "Tidak bermula",
      "dead_letter": "Gagal"
    },
    "elapsed": "Masa berlalu",
    "report": "Laporan",
    "show": "Tunjuk",
    "cancel": "Batal",
    "retry": "Cuba lagi",
    "site": "{{site}} · {{date}}",
    "kind": {
      "analysis.lulc": "Litupan tanah",
      "analysis.generate": "Analisis AI",
      "simulation.generate": "Reka bentuk"
    },
    "run": "{{kind}} · {{site}} · {{date}}"
  },
  "time": {
    "seconds": "{{s}} s",
    "minutes": "{{m}} min {{s}} s",
    "hours": "{{h}} j {{m}} min"
  },
  "layers": {
    "title": "Hasil",
    "item": "Litupan tanah",
    "opacity": "Kelegapan {{pct}}%",
    "legend": "Litupan tanah — pilih kelas untuk menyembunyikannya",
    "imagery": {
      "title": "Imejan",
      "detail": "{{label}} · {{gsd}} m"
    },
    "aiItem": "Analisis AI",
    "legendAi": "Analisis AI — pilih kelas untuk menyembunyikannya",
    "collapse": "Lipat",
    "expand": "Tunjuk"
  },
  "upload": {
    "title": "Atau muat naik fail sempadan",
    "hint": "GeoJSON, KML atau Shapefile dizip (dengan .prj), sehingga 5 MB.",
    "browse": "Pilih fail",
    "compactTitle": "Muat naik fail sempadan",
    "compactHint": "GeoJSON, KML atau Shapefile dizip · maks 5 MB",
    "tooLarge": "Fail itu melebihi 5 MB.",
    "reading": "Membaca fail…",
    "found": "{{count}} poligon · {{area}} ha · diukur dalam EPSG:{{crs}}",
    "fileCrs": "CRS fail: EPSG:{{crs}}",
    "name": "Nama tapak",
    "save": "Simpan sebagai tapak",
    "discard": "Buang"
  },
  "schedule": {
    "title": "Laporan berjadual",
    "none": "Laporan tapak ini belum dijadualkan.",
    "active": "{{frequency}} · semakan seterusnya {{date}}",
    "frequency": "Kekerapan",
    "frequencies": {
      "once": "Sekali sahaja",
      "weekly": "Mingguan",
      "monthly": "Bulanan",
      "quarterly": "Suku tahunan"
    },
    "every": {
      "weekly": "Setiap minggu",
      "monthly": "Setiap bulan",
      "quarterly": "Setiap suku tahun"
    },
    "onceNote": "Laporan ini dijalankan sekali sahaja, apabila anda menjalankan analisis.",
    "start": "Jadualkan laporan ini",
    "update": "Simpan perubahan",
    "stop": "Hentikan jadual",
    "failed": "Jadual tidak dapat disimpan.",
    "imageryNote": "Laporan baharu memerlukan rakaman yang lebih baharu daripada yang terakhir. Jika tiada, anda akan menerima notis.",
    "scheduled": "Berjadual",
    "lastCheck": {
      "started": "Semakan terakhir, {{date}}: rakaman {{captured}} lebih baharu, jadi laporan baharu dihasilkan.",
      "no_new_imagery": "Semakan terakhir, {{date}}: belum ada yang lebih baharu daripada rakaman {{captured}}, jadi tiada laporan baharu.",
      "refused": "Semakan terakhir, {{date}}: rakaman lebih baharu ditemui, tetapi laporan tidak dapat dimulakan."
    }
  },
  "imagery": {
    "title": "Imejan lebih baharu",
    "getNewer": "Dapatkan imejan lebih baharu",
    "hint": "Rakaman tapak ini daripada arkib Esri. Mendapatkan satu akan menyalinnya ke storan majlis anda; ia kemudian muncul di atas dan boleh dianalisis.",
    "searching": "Mencari rakaman…",
    "none": "Tiada rakaman meliputi tapak ini.",
    "unavailable": "Carian imejan tidak tersedia buat masa ini.",
    "detail": "{{source}} · {{resolution}} m",
    "unknownSource": "Esri",
    "get": "Dapatkan rakaman ini",
    "retry": "Cuba lagi",
    "ready": "Sedia",
    "status": {
      "pending": "Dalam giliran",
      "acquiring": "Memperoleh",
      "copying": "Menyalin",
      "ready": "Sedia",
      "failed": "Gagal"
    },
    "panel": {
      "noSites": "Lukis atau muat naik tapak dahulu; imejan dicari di atas tapak.",
      "providers": "Pembekal",
      "provider": {
        "esri": "Esri World Imagery",
        "google": "Google Satellite",
        "sentinel-2": "Sentinel-2",
        "landsat": "Landsat"
      },
      "mosaic": "Sehingga {{max}} ha",
      "sensor": "{{resolution}} m · sehingga {{max}} ha",
      "available": "Tersedia",
      "reason": {
        "not_configured": "Belum disediakan",
        "site_too_small": "Tapak terlalu kecil",
        "site_too_large": "Tapak terlalu besar"
      },
      "noProvider": "Tiada pembekal yang boleh melayani tapak ini.",
      "pickProvider": "Pilih pembekal untuk mencari imejan.",
      "search": "Cari",
      "latest": "Imej terkini",
      "latestNote": "Google hanya memberikan imej semasanya, tanpa tarikh rakaman.",
      "dates": "Dirakam",
      "maxCloud": "Litupan awan maksimum",
      "percent": "{{value}}%",
      "cloudCover": "Litupan awan {{value}}%",
      "showMore": "Tunjuk lagi ({{count}} lagi)",
      "preview": "Pratonton pada peta",
      "previewStop": "Sembunyikan pratonton",
      "previewState": {
        "loading": "Memuatkan pratonton…",
        "shown": "Pratonton pada peta",
        "failed": "Tiada pratonton untuk rakaman ini"
      },
      "preset": {
        "all": "Semua",
        "5y": "5 tahun",
        "1y": "1 tahun",
        "90d": "90 hari",
        "30d": "30 hari",
        "custom": "Pilihan"
      },
      "from": "Dari",
      "to": "Hingga",
      "results_one": "{{count}} rakaman",
      "results_other": "{{count}} rakaman",
      "sort": "Susun rakaman",
      "sortBy": {
        "newest": "Terbaharu dahulu",
        "oldest": "Terlama dahulu",
        "sharpest": "Paling tajam dahulu"
      },
      "sources": "Tapis mengikut sumber",
      "chosen_one": "{{count}} daripada 2 dipilih untuk dibandingkan",
      "chosen_other": "{{count}} daripada 2 dipilih untuk dibandingkan",
      "compare": "Bandingkan",
      "show": "Tunjuk",
      "analyse": "Analisis",
      "notAnalysable": "Terlalu kasar untuk litupan tanah: perlu 0.7 m sepiksel atau lebih halus",
      "download": "Muat turun GeoTIFF",
      "pick": "Banding",
      "incomplete": "Sesetengah tangkapan tidak disenaraikan: tarikhnya tidak dapat dibaca buat masa ini.",
      "searchAgain": "Cari semula"
    }
  },
  "compare": {
    "title": "Bandingkan rakaman",
    "close": "Tutup perbandingan",
    "mode": "Mod perbandingan",
    "modes": {
      "swipe": "Leret",
      "side": "Sebelah-menyebelah",
      "blend": "Adun"
    },
    "divider": "Gerakkan pembahagi",
    "blend": "Rakaman lebih baharu {{pct}}%",
    "loading": "Memuatkan rakaman…",
    "failed": "Rakaman tidak dapat dimuatkan.",
    "resultsTitle": "Bandingkan litupan tanah"
  },
  "documents": {
    "title": "Laporan",
    "noSites": "Lukis atau muat naik tapak dahulu; laporan dibuat daripada analisis sesebuah tapak.",
    "none": "Belum ada analisis bagi tapak ini. Setiap laporan dibuat daripada satu analisis — jalankan analisis dalam tab Analisis dahulu.",
    "goAnalyse": "Pergi ke Analisis",
    "loadFailed": "Laporan tidak dapat dimuatkan.",
    "analysis": "Analisis {{date}}",
    "analysisUndated": "Analisis (tarikh rakaman tidak direkodkan)",
    "compared": "Dibandingkan dengan {{date}}",
    "comparedEarlier": "Dibandingkan dengan analisis terdahulu",
    "firstAnalysis": "Analisis pertama tapak ini",
    "scheduled": "Berjadual",
    "open": "Buka laporan",
    "pdf": "PDF",
    "bundle": "Fail GIS",
    "make": "Buat laporan",
    "made_one": "{{count}} laporan dibuat daripada analisis ini",
    "made_other": "{{count}} laporan dibuat daripada analisis ini",
    "document": "{{paper}} {{orientation}} · versi {{version}}",
    "download": "Muat turun PDF",
    "status": {
      "queued": "Dalam giliran",
      "running": "Mencetak…",
      "succeeded": "Sedia",
      "failed": "Gagal",
      "cancelled": "Dibatalkan"
    },
    "template": {
      "site_analysis": "Analisis Tapak",
      "change_detection": "Pengesanan Perubahan",
      "discrepancy": "Percanggahan / Penguatkuasaan",
      "development_proposal": "Cadangan Pembangunan"
    },
    "templateHint": {
      "site_analysis": "Litupan tanah, bangunan dan rakaman, bagi satu tarikh.",
      "change_detection": "Apa yang berubah sejak analisis yang dibandingkan, didahulukan.",
      "discrepancy": "Di mana guna tanah berbeza daripada kadaster, untuk penguatkuasaan.",
      "development_proposal": "Pilihan pembangunan simulasi dan metriknya."
    },
    "section": {
      "cover": "Kulit",
      "site_summary": "Ringkasan tapak",
      "classification": "Peta dan statistik litupan tanah",
      "change": "Perubahan sejak analisis terdahulu",
      "imagery": "Imejan yang digunakan",
      "methodology": "Metodologi",
      "discrepancy": "Jadual percanggahan",
      "simulation": "Pilihan dan metrik simulasi",
      "compliance": "Keputusan pematuhan",
      "annotations": "Anotasi",
      "appendix": "Lampiran: asal usul data dan ID larian"
    },
    "reason": {
      "no_analysis": "Memerlukan analisis tapak",
      "no_earlier_report": "Memerlukan analisis yang dibandingkan dengan yang terdahulu",
      "needs_cadastre_comparison": "Memerlukan perbandingan kadaster, belum dibina",
      "needs_simulation": "Memerlukan simulasi, belum dibina",
      "needs_compliance": "Memerlukan semakan buku peraturan, belum dibina",
      "needs_annotations": "Memerlukan anotasi, belum dibina"
    },
    "required": "Sentiasa disertakan",
    "templates": "Templat",
    "sections": "Bahagian",
    "paper": "Kertas",
    "orientation": "Orientasi",
    "portrait": "Potret",
    "landscape": "Landskap",
    "submit": "Buat laporan",
    "cancel": "Batal",
    "loadingTemplates": "Memuatkan templat…",
    "startFailed": "Laporan tidak dapat dimulakan. Sila cuba lagi.",
    "quota": "Organisasi anda tiada baki kredit bagi tempoh ini.",
    "ran": "Dijalankan {{date}}",
    "pick": "Banding",
    "chosen_one": "{{count}} daripada 2 dipilih untuk dibandingkan",
    "chosen_other": "{{count}} daripada 2 dipilih untuk dibandingkan",
    "compareChosen": "Bandingkan litupan tanah",
    "compareWith": "Bandingkan dengan {{date}}",
    "compareWithEarlier": "Bandingkan dengan analisis terdahulu",
    "landCover": "Litupan tanah",
    "compareFailed": "Perbandingan tidak dapat dibuka.",
    "aiAnalysis": "{{label}} · {{date}}",
    "aiAnalysisUndated": "{{label}}",
    "aiBadge": "Analisis AI",
    "aiFallback": "Analisis AI"
  },
  "generate": {
    "captureOption": "{{date}} · {{provider}} · {{gsd}} m",
    "tier": "Saiz output",
    "tierAuto": "Automatik",
    "tiers": {
      "1K": "1K (kira-kira 1,000 px)",
      "2K": "2K (kira-kira 2,000 px)",
      "4K": "4K (kira-kira 4,000 px)"
    },
    "failed": "Imej tidak dapat dibuat. Cuba lagi.",
    "made": "{{width}} × {{height}} px",
    "aiNote": "Dibuat oleh model AI.",
    "show": "Tunjuk",
    "hide": "Sembunyi",
    "download": "GeoTIFF",
    "opacity": "Kelegapan {{pct}}%",
    "earlier": "Imej terdahulu",
    "subject": "Apa yang dicari",
    "subjectPlaceholder": "kereta, kolam renang, panel solar",
    "pictureHint": "Analisis AI bagi tangkapan yang dipilih, dilukis pada peta sebagai gambar.",
    "done": "Analisis selesai. Gambar ada pada peta.",
    "runDone": "Analisis selesai. Gambar ada pada peta, dan anda boleh menjalankannya semula.",
    "view": {
      "label": "Apa yang ditunjukkan",
      "polygons": "Poligon",
      "picture": "Gambar"
    },
    "areas": "Keluasan mengikut kelas",
    "classHa": "{{area}} ha",
    "classShare": "{{pct}}%",
    "report": "Laporan (PDF)",
    "measured": "{{area}} ha dipetakan dalam sempadan tapak",
    "fit": {
      "tooLarge": "Tapak ini terlalu besar untuk analisis ini dengan tangkapan ini. Lebarnya boleh sehingga kira-kira {{max}} m.",
      "tooSmall": "Tapak ini terlalu kecil untuk analisis ini.",
      "tooLargeModel": "Tapak ini terlalu besar untuk model litupan tanah dengan tangkapan ini.",
      "noneFits": "Tapak ini tidak sesuai dengan analisis yang dipilih. Pilih yang lain, atau tapak yang lebih kecil.",
      "someUnfit": "Analisis yang dikelabukan tidak boleh berfungsi pada tapak sebesar ini dengan tangkapan ini."
    }
  }
}
